import { ConfigProvider } from 'antd';
import { Locale } from 'antd/es/locale';
import en from 'antd/locale/en_GB';
import hr from 'antd/locale/hr_HR';
import 'dayjs/locale/hr';
import { useCallback, useContext, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './app.css';

import { themeConfig } from './context/antd-config/theme.config';
import { AuthContext } from './context/auth-context';
import i18n from './i18n';
import { AppRouter } from './router';

function App() {
  const { language } = useContext(AuthContext);
  const [locale, setLocale] = useState<Locale>(en);

  const checkLanguage = useCallback(() => {
    i18n.changeLanguage(language);
    if (language === 'hr') {
      setLocale(hr);
    } else {
      setLocale(en);
    }
  }, [language]);

  useEffect(() => {
    checkLanguage();
  }, [checkLanguage]);

  return (
    <ConfigProvider locale={locale} theme={themeConfig}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
